var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgN2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "n2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34053",
    "data-name": "\\uD328\\uC2A4 34053",
    d: "M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm0,18.125A8.125,8.125,0,1,1,18.125,10,8.125,8.125,0,0,1,10,18.125ZM12.112,12.6H9.872c1.095-1.291,2.856-2.779,2.856-4.456A2.5,2.5,0,0,0,9.986,5.634,3.013,3.013,0,0,0,6.921,8.411a.862.862,0,0,0,.94.88C9.1,9.291,8.427,7.3,9.909,7.3a.929.929,0,0,1,.928.929,1.924,1.924,0,0,1-.451,1.122c-.979,1.326-2.138,2.412-3.207,3.606a.981.981,0,0,0-.3.615c0,.555.438.8,1,.8h4.3a.871.871,0,0,0,.928-.874A.908.908,0,0,0,12.112,12.6Z",
    transform: "translate(0 0)",
    fill: "#2389a8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgN2);
export default __webpack_public_path__ + "static/media/n2.0e329b914be85f832eef80b711d30418.svg";
export { ForwardRef as ReactComponent };